import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {Image} from '@app/components/Image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const PurpleClubSection: FunctionComponent = () => {
	const {t} = useTranslation();
	return (
		<LandingIllustrationSection
			imagePosition="left"
			description={
				<>
					<LandingHeading
						as="h2"
						dangerouslySetInnerHTML={{
							__html: t(
								'purpleclublandingpage_title_winticketsforexcluxp_standalone-web',
								{
									ns: 'features',
								},
							),
						}}
					/>
					<LandingParagraph>
						{t(
							'purpleclublandingpage_text_winticketsforexcluxp_standalone-web',
							{
								ns: 'features',
							},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					aspectRatio="2880/1012"
					src="de595e0458207988cbb5a53fb09e77fd.jpg"
					alt={t('metatag_text_highfidelitymusic_standalone-web', {
						ns: 'common',
					})}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'purpleclub', eventlabel: 'purpleclub'}}
					href="/features/purpleclub"
				>
					{t('purpleclublandingpage_action_discoverpurpleclub_standalone-web', {
						ns: 'purpleclub',
					})}
				</LandingButtonLink>
			}
		/>
	);
};
